module.exports = __webpack_public_path__ + "static/media/image018.91a4702e.jpg";